
import * as React from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import PageDefault from '../../components/PageDefault';
import api from '../../services/api';
import apiDAM from '../../services/apiDAM';

export default function EmitirNadaConsta() {
  const [carregando, setCarregando] = React.useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const contribuinteId = React.useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const queryId = queryParams.get('contribuinteId');
    return params.contribuinteID || queryId || '';
  }, [location.search, params.contribuinteID]);

  const handleEmitir = React.useCallback(() => {
    if (!contribuinteId) {
      toast.error('Informe o ID do contribuinte');
      return;
    }

    setCarregando(true);

    api.get(`/contribuinte/${contribuinteId}/nada-consta`)
      .then(res => {

        const nadaConsta = res.data.nadaConsta;
        const contribuinteReturn = res.data.contribuinteId;

        if (!nadaConsta) {
          setCarregando(false);
          toast.error('Contribuinte devedor de tributos, verifique as cobranças em aberto!');
          return;
        }
        
        const payload = { contribuinteId: contribuinteReturn };

        apiDAM.post('/nada-consta', payload, {
          responseType: 'blob',
        })
          .then(resDam => {
            setCarregando(false);
            const blob = new Blob([resDam.data], {
              type: 'application/pdf',
            });
            const url = window.URL.createObjectURL(blob);
            window.open(url);

            setTimeout(() => {
              navigate(-1);
            }, 300);
          })
          .catch(err => {
            setCarregando(false);
            const message = err?.response?.data?.message;
            toast.error(message || 'Ocorreu um erro ao emitir o nada consta');
          })
      })
      .catch(err => {
        setCarregando(false);
        
        if (err?.response?.status === 404) {
          toast.warning('Por favor, procurar o setor de tributos da Prefeitura para realizar seu cadastro!');
        } else {
          toast.error(err?.response?.data?.message || 'Ocorreu um erro, verifique os dados');
        }
      });
  }, [contribuinteId, navigate]);

  React.useEffect(() => {
    if (!contribuinteId) {
      return;
    }
    handleEmitir();
  }, [contribuinteId, handleEmitir]);

  const handleBack = () => {
    navigate(-1);
  }

  return (
    <PageDefault carregando={carregando} title='Emitir Nada Consta'>
      <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
        <Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
          <Typography variant="h6" gutterBottom>
            Emitir Nada Consta
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Contribuinte ID: {contribuinteId || '-'}
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
              Voltar
            </Button>
            <Button variant="contained" onClick={handleEmitir} disabled={!contribuinteId} sx={{ mt: 3, ml: 1 }}>
              Emitir novamente
            </Button>
          </Box>
        </Paper>
      </Container>
    </PageDefault>
  );
}
